import React, { useEffect, useState } from 'react';
import Axios from 'axios';

const issuer = (process.env.REACT_APP_MCP_OAUTH_ISSUER || 'https://mcp.salesblink.io').replace(/\/+$/, '');

const bridgePath = () => `${window.location.pathname}${window.location.search}`;

const returnTo = () => {
  const value = new URLSearchParams(window.location.search).get('return_to');
  return value && value.startsWith(`${issuer}/oauth/`) ? value : `${issuer}/oauth/authorize/resume`;
};

export default function McpOauthBridge() {
  const [message, setMessage] = useState('Connecting your SalesBlink account...');

  useEffect(() => {
    const connect = async () => {
      let token;
      try {
        token = JSON.parse(localStorage.getItem('user') || 'null')?.token;
      } catch {
        token = null;
      }

      if (!token) {
        window.sessionStorage.setItem('postAuthRedirect', bridgePath());
        window.location.replace('/signin');
        return;
      }

      try {
        const response = await Axios.post(
          '/api/mcp-oauth/handshake',
          {},
          { headers: { Authorization: `Bearer ${token}` } },
        );
        const continueUrl = new URL(response.data.continue_url);
        if (continueUrl.origin !== issuer || continueUrl.pathname !== '/oauth/continue') {
          throw new Error('Invalid OAuth continuation URL');
        }
        continueUrl.searchParams.set('return_to', returnTo());
        window.location.replace(continueUrl.toString());
      } catch (error) {
        if (error.response?.status === 401) {
          window.sessionStorage.setItem('postAuthRedirect', bridgePath());
          window.location.replace('/signin');
          return;
        }
        setMessage('SalesBlink could not complete the connection. Please return to your assistant and try again.');
      }
    };

    connect();
  }, []);

  return <p>{message}</p>;
}
